import { defineComponent as a, useId as i, createElementBlock as o, openBlock as d, createCommentVNode as t, renderSlot as l } from "vue";
const n = ["id", "aria-labelledby", "role"], r = ["id"], m = /* @__PURE__ */ a({
  __name: "ScalarComboboxOptionGroup",
  props: {
    id: { default: () => i() },
    hidden: { type: Boolean, default: !1 }
  },
  setup(s) {
    return (e, p) => (d(), o("div", {
      id: e.id,
      "aria-labelledby": e.id ? `${e.id}-label` : void 0,
      class: "contents",
      role: e.hidden ? void 0 : "group"
    }, [
      e.hidden ? t("", !0) : (d(), o("div", {
        key: 0,
        id: `${e.id}-label`,
        class: "min-w-0 truncate px-2.5 py-1.5 text-c-2"
      }, [
        l(e.$slots, "label")
      ], 8, r)),
      l(e.$slots, "default")
    ], 8, n));
  }
});
export {
  m as default
};
